<template>
  <div
    :class="`${name}-container`"
    @click="handleChange"
  >
    <img
      :src="src"
      :class="`${name}-container_img`"
    >
    <div
      :class="`${name}-container_label`"
    >
      {{ label }}
    </div>
    <vi-checkbox
      @click="(e) => e.stopPropagation()"
      :class="`${name}-container_checkbox`"
      @change="$emit('change')"
      v-model="checked"
    />
  </div>
</template>
<script>
import { defineComponent } from 'vue-demi';
import teaTracker from '@/tea-tracker';
import { TEA_EVENT } from '@/const/state/TeaNames';

const name = 'placement';
export default defineComponent({
  name,
  props: {
    src: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    checked: {
      type: Boolean,
      required: true
    }
  },
  setup(props, { emit }) {
    const handleChange = e => {
      teaTracker.trackEvent(TEA_EVENT.USER_CLICK_TIKTOK_OR_PANGLE, {
        placement: props.label
      });
      e?.stopPropagation();
      emit('change');
    };
    return {
      name,
      handleChange,
    };
  }
});
</script>
<style scoped lang="scss">
.placement-container {
  position: relative;
  height: 42px;
  margin-bottom: 8px;
  &_img {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    height: 40px;
    width: 40px;
  }
  &_label {
    position: absolute;
    margin-left: 12px;
    height: 40px;
    width: 40px;
    left: 40px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 42px;
    color: var(--ks-sys-color-neutral-highOnSurface);
  }
  &_checkbox {
    position: absolute;
    margin: auto;
    padding-top: 8px;
    height: 40px;
    width: 40px;
    top: 0;
    right: 0;
    bottom: 0;

  }
}
</style>
